import image1 from "../assets/t-image1.png";
import image2 from "../assets/t-image2.jpg";
import image3 from "../assets/t-image3.jpg";

export const testimonialsData = [
  {
    image: image1,
    review:
      "I made the right choice by choosing the Fitclub and by choosing the right plan and program I already achieved my ideal body!",
    name: 'MATHEW HENDRICKSON',
    status : 'ENTREPRENEUR'
  },
  {
    image: image2,
    review: "I appreciate the gym's cleanliness and friendly staff; however, the limited class schedule could be improved to cater to a wider range of members ",
    name: 'JOHN KEVIN',
    status: 'COACH'
  },
  {
    image : image3,
    review:"The fitness gym provides a motivating atmosphere with knowledgeable trainers and a variety of equipment, making every workout session effective and enjoyable",
    name: 'FRANKLIN',
    status: "CUSTOMER"
  }
];
